/** Chave legada (global por browser — não usar para decidir exibição do modal). */
export const TERMOS_USO_LEGACY_STORAGE_KEY = 'visualizou_termos';

export function termosUsoStorageKey(clienteId: number | string): string {
    return `visualizou_termos_${clienteId}`;
}

export function hasTermosAceitosLocal(clienteId: number | string): boolean {
    return localStorage.getItem(termosUsoStorageKey(clienteId)) === '1';
}

export function setTermosAceitosLocal(clienteId: number | string): void {
    localStorage.setItem(termosUsoStorageKey(clienteId), '1');
}
